export default "__VITE_ASSET__ClpYPyLA__"